import { Button, DraggableWindowHeader } from "@hoylu/client-common";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashboardOption } from "@/enums/DashboardOption.enum";
import * as workspacesActions from "../../state/workspaces/workspaces.actions";
import { selectSelectedWorkspace } from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import Styles from "./LinkedMasterDialog.module.css";
import { Modal } from "./Modal";

export const LinkedMasterDialog = () => {
  const dispatch = useDispatch();

  const tLinkedMasterDialog = useI18n("LINKED_MASTER_DIALOG.");
  const tClose = useI18n("CLOSE_BUTTON.");

  const selectedWorkspace = useSelector(selectSelectedWorkspace);

  const openChangeMasterDialog = () =>
    dispatch(
      workspacesActions.activateDashboardOption({
        optionType: DashboardOption.CHANGE_MASTER,
        workspaceId: selectedWorkspace?.workspaceId,
      }),
    );

  const cancelDashboardOption = () =>
    dispatch(workspacesActions.cancelDashboardOption());

  return (
    <Modal allowContentToOverflow handleOutsideClick={cancelDashboardOption}>
      <div
        className={Styles.linkedMasterDialog}
        data-test-id="linked-master-ws-dialog"
      >
        <DraggableWindowHeader
          close={tClose("CLOSE")}
          onClose={cancelDashboardOption}
          title={tLinkedMasterDialog("TITLE")}
        />
        <span className={Styles.subtitle}>
          {tLinkedMasterDialog("SUBTITLE")}
        </span>
        <div className={Styles.items}>
          <div className={Styles.item}>
            <span>{tLinkedMasterDialog("NAME_FIELD")}</span>
            {/** biome-ignore lint/style/noJsxLiterals: Expected not localized */}
            <span>Workspace Name</span>
          </div>
          <div className={Styles.item}>
            <span>{tLinkedMasterDialog("ID_FIELD")}</span>
            {/** biome-ignore lint/style/noJsxLiterals: Expected not localized */}
            <span>Workspace ID</span>
          </div>
        </div>
        <div className={Styles.buttons}>
          <Button
            dataTestId={tLinkedMasterDialog("CANCEL")}
            onClick={cancelDashboardOption}
            type="secondary"
          >
            {tLinkedMasterDialog("CANCEL")}
          </Button>
          <Button
            dataTestId="change-linked-master"
            onClick={openChangeMasterDialog}
            type="primary"
          >
            {tLinkedMasterDialog("CHANGE_MASTER")}
          </Button>
          <Button dataTestId="edit-content" onClick={() => {}} type="primary">
            {tLinkedMasterDialog("EDIT_CONTENT")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LinkedMasterDialog;
